export default "__VITE_ASSET__DO5WBfyw__"